import PropTypes from "prop-types";
import styled from "styled-components";
import React from "react";

const Svg = styled.svg`
  user-select: none;
  display: inline-block;
  fill: ${props => props.fill || "currentColor"};
  flex-shrink: 0;
`;

function SvgIcon(props) {
  const { children, className, color, titleAccess, viewBox, ...other } = props;

  return (
    <Svg
      className={className}
      focusable="false"
      viewBox={viewBox}
      color={color}
      aria-hidden={titleAccess ? "false" : "true"}
      {...other}>
      {titleAccess ? <title>{titleAccess}</title> : null}
      {children}
    </Svg>
  );
}

SvgIcon.propTypes = {
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   */
  color: PropTypes.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string,
};

SvgIcon.defaultProps = {
  viewBox: "0 0 24 24",
  className: "",
  color: "",
  titleAccess: "",
};

export default SvgIcon;
